import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

const useStyles = makeStyles(() => ({
	root: {
		height: (props) => (props.isFullscreen ? '98vh' : '80vh'),
	},
}));

const PowerBIDashboard = (props) => {
	const { url, reportId, accessToken } = props;
	const [isFullscreen, setIsFullscreen] = useState(false);

	const classes = useStyles({ isFullscreen });

	useEffect(() => {
		const checkFullscreen = () => {
			setIsFullscreen(!!document.fullscreenElement);
		};

		document.addEventListener('fullscreenchange', checkFullscreen);

		return () => {
			document.removeEventListener('fullscreenchange', checkFullscreen);
		};
	}, []);

	if (!url) {
		return null;
	}

	return (
		<PowerBIEmbed
			embedConfig={{
				type: 'report',
				id: reportId,
				embedUrl: url,
				accessToken,
				tokenType: models.TokenType.Aad,
				settings: {
					panes: {
						filters: {
							expanded: false,
							visible: true,
						},
					},
					background: models.BackgroundType.Default,
				},
			}}
			cssClassName={classes.root}
			getEmbeddedComponent={(embeddedReport) => {
				window.report = embeddedReport;
			}}
		/>
	);
};

PowerBIDashboard.propTypes = {
	url: PropTypes.string.isRequired,
	reportId: PropTypes.string.isRequired,
	accessToken: PropTypes.string.isRequired,
};

export default PowerBIDashboard;
